// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 982) return "static/chunks/982.b56499fc739b7094.js";
	if (chunkId === 306) return "static/chunks/306.219f0862ea664f30.js";
	if (chunkId === 496) return "static/chunks/graphql-print.83edc8afc0370428.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"22":"8cbe08c9894df25a","431":"29564a12b8cca8e4","838":"8a71f4bfa9a4a37d","939":"163c022470a9e51a"}[chunkId] + ".js";
};